import { CategoryID } from '../src/types/PartsCategory';

export type AssetColor = string[];

const assetColors: { [key: CategoryID]: AssetColor[] } = {
  '1. Body': [
    ['#EAE2DF', '#C3B8BE'],
    ['#E7DBD5', '#B9A1A3'],
    ['#DDBCB1', '#A9838A'],
    ['#B39192', '#A9838A'],
    ['#6D5156', '#413449'],
  ],
  '2. Eyes': [
    // pre-selected eye colors
    ['#302E40', '#182132'],
    ['#C8E792', '#9898AD'],
    ['#A583A6', '#443854'],
    ['#B0D9DA', '#9898AD'],
    ['#804A5F', '#000913'],
    // original eye colors
    ['#F4C88F', '#87797C'],
    ['#E5A2FF', '#A696AE'],
    ['#9BC4F1', '#596373'],
    ['#D46CD1', '#685969'],
    ['#EA7D87', '#675659'],
    ['#D7E0ED', '#91A19A'],
    ['#8EEEA6', '#95B39F'],
  ],
  '4. Hair': [
    ['#3A4258', '#282F42'],
    ['#C8BDAF', '#B3949B'],
    ['#C1A1CD', '#A97EC0'],
    ['#977F75', '#695A52'],
    ['#758392', '#4A576B'],
    ['#937192', '#694A6B'],
    ['#A46369', '#70444C'],
    ['#A7D3B2', '#84C299'],
    ['#BFBAB8', '#A6A1A0'],
    ['#A7AECC', '#8490BF'],
    ['#E5E2BA', '#D1D08C'],
    ['#ECDBDC', '#CFABC0'],
    ['#839175', '#536652'],
    ['#2B417B', '#233669'],
    ['#F2CA7F', '#A88B98'],
    ['#D1736D', '#7D667E'],
  ],
};

export default assetColors;
